import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { FabricSqlCopySink } from 'app/model/pipeline/copysink/fabric-sql.copysink';
import { sqlSinkAdapts } from './sql.sink.adapter';
import { SqlServerSinkAdapter } from './sql.server.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricSqlCopySink),
    asynchronous: true,
    adapts: sqlSinkAdapts
})
export class FabricSqlSinkAdapter extends SqlServerSinkAdapter {}
